import { render } from "./Loader.svg?vue&type=template&id=2f2ad319"
const script = {}
script.render = render

export default script